/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Antigravity_Cli_AddInputs */

const en_mcp_antigravity_cli_add = /** @type {(inputs: Mcp_Antigravity_Cli_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run this command, then start agy and run /mcp to sign in.`)
};

const es_mcp_antigravity_cli_add = /** @type {(inputs: Mcp_Antigravity_Cli_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecuta este comando, luego inicia agy y ejecuta /mcp para iniciar sesión.`)
};

/**
* | output |
* | --- |
* | "Run this command, then start agy and run /mcp to sign in." |
*
* @param {Mcp_Antigravity_Cli_AddInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_antigravity_cli_add = /** @type {((inputs?: Mcp_Antigravity_Cli_AddInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Antigravity_Cli_AddInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_antigravity_cli_add(inputs)
	return en_mcp_antigravity_cli_add(inputs)
});